// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: '75bb9a2d-f7d0-46ce-a39b-2cc244d02815',
      type: 'Sprite',
      name: 'blackOverlay',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'bg',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4',
      type: 'Container',
      name: 'popup',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '4348ec73-bce6-4cd7-9ce3-114ff4b03ebf',
      type: 'Sprite',
      name: 'backgroundSprite1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Chest',
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '4996aa5c-09f8-4c3d-be18-d88b79bacae5',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 330,
      y: -580,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '92c0c901-0f97-4b3b-8e4b-e0761e3d5e5e',
      type: 'Text',
      name: 'titleText',
      className: '',
      x: 0,
      y: -551,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Golden Head Start',
      localize: true,
      maxWidth: 430,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x5d058a',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4',
      data: {
        translations: {
          en_US: 'Golden Head Start',
          it_IT: 'Partenza Dorata',
          fr_FR: 'Démarrage Doré',
          de_DE: 'Goldener Startvorteil',
          es_ES: 'Comienzo Dorado',
          pt_PT: 'Arranque Dourado',
          pl_PL: 'Złoty Start',
          nl_NL: 'Gouden Voorsprong',
          ko_KR: '골든 헤드 스타트',
          ja_JP: 'ゴールデン・ヘッドスタート'
        }
      }
    },
    {
      id: '3f90b48f-384e-44f1-b42b-cfe9047f5436',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 20,
      y: -491,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Xd XXh',
      localize: false,
      maxWidth: 140,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '8c551070-3a96-4f27-9bec-b25ad1641258',
      type: 'Text',
      name: 'descriptionText',
      className: '',
      x: 0,
      y: -420,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Instant Gold. Big boost. No limits!',
      localize: true,
      maxWidth: 598,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 550,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4',
      data: {
        translations: {
          en_US: 'Instant Gold. Big boost. No limits!',
          it_IT: 'Oro istantaneo. Grande spinta. Nessun limite!',
          fr_FR: 'Or instantané. Grosse impulsion. Aucune limite !',
          de_DE: 'Sofort-Gold. Riesiger Schub. Keine Grenzen!',
          es_ES: 'Oro instantáneo. Gran impulso. ¡Sin límites!',
          pt_PT: 'Ouro instantâneo. Grande impulso. Sem limites!',
          pl_PL: 'Natychmiastowe złoto. Potężny zastrzyk mocy. Bez limitów!',
          nl_NL: 'Direct goud. Grote boost. Geen limieten!',
          ko_KR: '즉시 골드. 강력한 부스트. 한계 없음!',
          ja_JP: '即時ゴールド。大きなブースト。制限なし！'
        }
      }
    },
    {
      id: 'affa8efc-eecd-4f2e-ad57-0f9293d7c55e',
      type: 'Container',
      name: 'badgeContainer',
      className: '',
      x: 292,
      y: -258,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '5d5cb739-4621-46b0-8fc7-6c78f4ed83b4',
      type: 'Container',
      name: 'rewardSlot1',
      className: '',
      x: -110,
      y: 40,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '9e2ac9bd-8d9e-4968-b614-ad91918c1089',
      type: 'Container',
      name: 'coinPile',
      className: '',
      x: 11,
      y: -97,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: '456bb7aa-37e7-4bb0-987d-8466812d735e',
      type: 'Layout',
      name: 'buyButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 455,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'f1877d2d-ae36-432a-b134-41040740615e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 618,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 20,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Black_Blur_Square',
      parent: 'afaf8ca0-bbe0-4c98-a6be-e3d9ea943bc4'
    },
    {
      id: 'e9137871-f099-4dc7-83a1-be57634fbbaa',
      type: 'Text',
      name: 'badgeTextBig',
      className: '',
      x: 8,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '400%',
      localize: false,
      maxWidth: 126,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x5d058a',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'affa8efc-eecd-4f2e-ad57-0f9293d7c55e'
    },
    {
      id: 'a5c3e892-e436-497e-9e6e-a5aff69ff6eb',
      type: 'Text',
      name: 'badgeTextSmall',
      className: '',
      x: -6,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EXTRA',
      localize: false,
      maxWidth: 100,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x5d058a',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'affa8efc-eecd-4f2e-ad57-0f9293d7c55e'
    },
    {
      id: 'b58596cd-5232-4b72-9801-9cd78e57befa',
      type: 'Sprite',
      name: '',
      className: '',
      x: -251,
      y: 143,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16444793,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: 'a76187b8-f9e0-4f66-94f9-57ef2d5c181a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 262,
      y: 154,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16444793,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: 'f31e79d8-fbae-4f7f-8aed-2324ec630ae6',
      type: 'Text',
      name: '',
      className: 'replaceText_SPL',
      x: 303,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<amount>h',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089',
      data: {
        replaceText_SPL: {
          '<amount>': '24 '
        }
      }
    },
    {
      id: 'b8bb0d62-330a-4497-9c6f-7e6da416293b',
      type: 'Text',
      name: '',
      className: '',
      x: -303,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: '26229f1e-2a96-4ca9-a0aa-c05ec08a2e09',
      type: 'Sprite',
      name: '',
      className: '',
      x: -303,
      y: 172,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: '0c35fbf5-ca04-46d3-80fe-31a696cd9e9e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 303,
      y: 182,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: 'a675cdb4-a479-4306-97f8-387bf2a17c5d',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x2,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: 'a2a475b5-c240-4c20-b738-702a2b848b0a',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: '298dc0f0-0f61-467c-9877-d56b8947b748',
      type: 'Sprite',
      name: '',
      className: '',
      x: 304,
      y: 171,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Infinity',
      parent: '9e2ac9bd-8d9e-4968-b614-ad91918c1089'
    },
    {
      id: 'a15fadeb-9308-4525-af4e-9aff5ae38524',
      type: 'Text',
      name: 'buttonLabel',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<price>',
      localize: false,
      maxWidth: 340,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006100',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '456bb7aa-37e7-4bb0-987d-8466812d735e'
    },
    {
      id: '22c9b349-9304-4877-8813-c23e7c434e65',
      type: 'Sprite',
      name: '',
      className: '',
      x: -60,
      y: 88,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: '0db2c818-808a-4dc9-b71a-3349f420262c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -28,
      y: 137,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16759862,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: '5b00d12d-329c-48d4-b1d7-f0c9ac8aae14',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: '267d54f4-4286-4ebd-b21d-a4b5160f92d2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 18,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: 'f65ba8bb-8f9b-4f86-87e0-44b48dad92fb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 77,
      y: 105,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: '6b7495fa-7fc7-4fe4-b1a5-068845a9960b',
      type: 'Sprite',
      name: '',
      className: '',
      x: -90,
      y: 154,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: 'd2962c80-994a-4385-8020-6e083cd862d3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 98,
      y: 166,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: 'a8be0233-8edd-45e3-9424-c2b0d8f26cc0',
      type: 'Sprite',
      name: 'sparkle1',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: '2db83dbe-5768-4865-a938-7f19650335b0',
      type: 'Sprite',
      name: 'sparkle2',
      className: '',
      x: -68,
      y: 106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    },
    {
      id: 'e25c5256-7586-4d18-9de7-f680a0be77fd',
      type: 'Sprite',
      name: 'sparkle3',
      className: '',
      x: 72,
      y: 165,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'a2a475b5-c240-4c20-b738-702a2b848b0a'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  animations: [
    {
      id: '92e29bb3-ccac-43f6-a690-78df5cece06e',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 800,
      blocks: [
        {
          id: '11fc77fa-9ee9-434a-b808-d1b37cce85f7',
          type: 'Setter',
          name: 'blackOverlayAlpha',
          track: 0,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'blackOverlay',
          disabled: false
        },
        {
          id: '8cbd76da-34c7-48cf-b5a5-26903970aa76',
          type: 'Setter',
          name: 'backgroundSprite1Alpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'backgroundSprite1',
          disabled: false
        },
        {
          id: 'b23f16bb-45d1-4396-a72c-65807d9eeeb5',
          type: 'Setter',
          name: 'closeButtonScale',
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          disabled: false
        },
        {
          id: '09319710-f9d9-41a7-8840-25272cb5a130',
          type: 'Setter',
          name: 'titleTextAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'titleText',
          disabled: false
        },
        {
          id: '93b957df-8acb-475a-94b7-1d8a907334d0',
          type: 'Setter',
          name: 'timerTextAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'timerText',
          disabled: false
        },
        {
          id: '61050fde-2056-478a-9e8a-bd4edd5e9a6f',
          type: 'Setter',
          name: 'descriptionTextAlpha',
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'descriptionText',
          disabled: false
        },
        {
          id: '84ba7de7-4f55-4d8c-910d-a5578963b91e',
          type: 'Setter',
          name: 'badgeTextAlpha',
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'badgeText',
          disabled: false
        },
        {
          id: '26291945-44e1-4d2d-a6e1-39667614c385',
          type: 'Setter',
          name: 'rewardSlot1Scale',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'coinPile',
          disabled: false
        },
        {
          id: 'fee7456b-1979-463a-bf9e-2018139ee72a',
          type: 'Setter',
          name: 'buttonScale',
          track: 15,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'button',
          disabled: false
        },
        {
          id: 'ce993e13-ee04-4ee5-bda1-2ee14faddd51',
          type: 'Setter',
          name: 'limitTextAlpha',
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'limitText',
          disabled: false
        },
        {
          id: '849d0bb3-25c5-43ca-8621-ed46a302ad41',
          type: 'Setter',
          name: 'badgeText2Alpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'badgeText2',
          disabled: false
        },
        {
          id: '35d68a55-fdbe-416b-b391-25f296f6fcf5',
          type: 'Setter',
          name: 'badgeScale0',
          track: 17,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'badgeContainer',
          disabled: false
        },
        {
          id: 'e8cd4bf8-4a75-4643-a5de-083e317078d4',
          type: 'Tween',
          name: 'blackOverlayAlpha',
          duration: 300,
          track: 0,
          target: {
            alpha: 0.9
          },
          startAt: 10,
          sourceName: 'blackOverlay',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b4877520-e833-4a13-a561-91b51eccc4e9',
          type: 'Tween',
          name: 'badgeText2Alpha',
          duration: 500,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'badgeText2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f519908d-d9a5-407a-9ebd-d92d180e0825',
          type: 'Tween',
          name: 'badgeTextAlpha',
          duration: 500,
          track: 9,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'badgeText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'fbbfaa07-db89-4e22-a886-5308cb2e2e04',
          type: 'Tween',
          name: 'descriptionTextAlpha',
          duration: 500,
          track: 8,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'descriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6568af3a-2c55-4048-9b14-bdffc349550c',
          type: 'Tween',
          name: 'timerTextAlpha',
          duration: 500,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'timerText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '446cd7e6-4f2a-4a9b-aa98-dbe57724e909',
          type: 'Tween',
          name: 'titleTextAlpha',
          duration: 500,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'titleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ea4fc78d-5f6a-41dc-bb04-0efd1fcc36a5',
          type: 'Tween',
          name: 'backgroundSprite1Alpha',
          duration: 500,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 30,
          sourceName: 'backgroundSprite1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3b967f7f-f721-4b73-8528-a5e6bba9cc6d',
          type: 'Tween',
          name: 'buttonScale',
          duration: 300,
          track: 15,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3e8ff850-5ff2-41e2-a861-9e40b5d62fd7',
          type: 'Tween',
          name: 'rewardSlot1Scale',
          duration: 300,
          track: 10,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 100,
          sourceName: 'coinPile',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'fee8ee5e-1322-4970-ad77-e4e1e50ffa24',
          type: 'Tween',
          name: 'closeButtonScale',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b0d7b41b-e8ca-42ad-b391-42c649a97d48',
          type: 'Tween',
          name: 'badgeScaleAnim',
          duration: 400,
          track: 17,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 300,
          sourceName: 'badgeContainer',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '32b04482-ce1b-48e4-8825-a7185ad53f9e',
          type: 'Tween',
          name: 'buttonScale',
          duration: 150,
          track: 15,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd73cc777-dccf-4b34-b575-9bd43d524cda',
          type: 'Tween',
          name: 'rewardSlot1Scale',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 400,
          sourceName: 'coinPile',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'cde0108c-7da4-419d-acd0-638d6cbb20c3',
          type: 'Tween',
          name: 'closeButtonScale',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5aa7e277-ee23-4348-9ff3-76b1ba5e184f',
          type: 'Tween',
          name: 'limitTextAlpha',
          duration: 300,
          track: 16,
          target: {
            alpha: 1
          },
          startAt: 500,
          sourceName: 'limitText',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '6484202e-9c3a-4076-bcec-1fdb086e187f',
      name: 'Disappear',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: '9dabcc51-dcde-430d-b8ef-765066161d17',
          type: 'Tween',
          name: 'closeButtonScale',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ab0a7e99-3a18-415e-8b8d-7c60892d61fd',
          type: 'Tween',
          name: 'rewardSlot1Scale',
          duration: 300,
          track: 10,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'coinPile',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4a686d11-47e4-4028-934e-50046dad06cf',
          type: 'Tween',
          name: 'buttonScale',
          duration: 300,
          track: 15,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5fc5db0d-5d50-41fd-a561-ddbfd982f613',
          type: 'Tween',
          name: 'badgeText2Alpha',
          duration: 500,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'badgeText2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'bc6cdc16-cb04-4c03-9f80-44701d0c2ead',
          type: 'Tween',
          name: 'limitTextAlpha',
          duration: 500,
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'limitText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8fe5ef9e-8d7e-4879-a7b3-38b3bd0c9821',
          type: 'Tween',
          name: 'badgeTextAlpha',
          duration: 500,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'badgeContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a647f505-6e0b-4ea4-b2c3-4c0141c4e1f3',
          type: 'Tween',
          name: 'descriptionTextAlpha',
          duration: 500,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'descriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '91a65b25-373b-49f5-8898-f1807f2118cb',
          type: 'Tween',
          name: 'timerTextAlpha',
          duration: 500,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'timerText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b1978dca-0708-4863-b4ca-90261265ffed',
          type: 'Tween',
          name: 'titleTextAlpha',
          duration: 500,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'titleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b29f2367-f769-4591-9b70-aa7d8ea7a0ea',
          type: 'Tween',
          name: 'backgroundSprite1Alpha',
          duration: 500,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'backgroundSprite1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f62768a4-c867-4fe9-92e5-8d043b3132c8',
          type: 'Tween',
          name: 'blackOverlayAlpha',
          duration: 500,
          track: 0,
          target: {
            alpha: 0
          },
          startAt: 130,
          sourceName: 'blackOverlay',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b6550108-e0ff-4537-8c5c-be44a7ef6a99',
          type: 'Tween',
          name: 'buttonScale',
          duration: 150,
          track: 15,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 300,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aab8db8a-f2a1-4531-97c6-d391d0c961d0',
          type: 'Tween',
          name: 'rewardSlot1Scale',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 300,
          sourceName: 'coinPile',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b716b843-6de4-45a1-9380-136a3fa226d4',
          type: 'Tween',
          name: 'closeButtonScale',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 300,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '4523d892-eecc-4ead-97d3-13c160f00190',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '7d2957f9-a771-4b97-9b60-93748c692d01',
          type: 'Setter',
          name: 'sparkle1',
          track: 2,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 100,
          sourceName: 'sparkle1',
          disabled: false
        },
        {
          id: '12611a37-f02e-418a-86de-f863e8ed2b04',
          type: 'Tween',
          name: 'sparkle1_1',
          duration: 150,
          track: 2,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 110,
          sourceName: 'sparkle1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2db4e69b-197c-4539-9afc-98fef1210375',
          type: 'Setter',
          name: 'sparkle2',
          track: 3,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 300,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: 'e7787bd1-7aec-467b-ba00-290e1b5ed0f8',
          type: 'Tween',
          name: 'sparkle1_1_copy_1',
          duration: 150,
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 310,
          sourceName: 'sparkle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5daf0691-55a7-430f-af8a-48657e5efebe',
          type: 'Tween',
          name: 'sparkle1_1_copy_1_copy_1',
          duration: 150,
          track: 2,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 310,
          sourceName: 'sparkle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f0bb80c7-0452-4fdf-ac55-c0f503da802b',
          type: 'Setter',
          name: 'sparkle2_copy',
          track: 4,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 500,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: 'a6328070-5a38-413e-bd7a-82a0d068594b',
          type: 'Tween',
          name: 'sparkle3',
          duration: 150,
          track: 4,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 510,
          sourceName: 'sparkle3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '01c5cb7d-4cea-4b33-b8f0-8eb665470602',
          type: 'Setter',
          name: 'sparkle2_copy_copy',
          track: 3,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 1100,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: '5a2ee7d2-d591-4f6e-b0ae-629865b568fd',
          type: 'Tween',
          name: 'sparkle3_copy',
          duration: 150,
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1110,
          sourceName: 'sparkle3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '73362942-e1cd-4aba-b867-97ec60549231',
          type: 'Setter',
          name: 'sparkle2_copy_1',
          track: 2,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 1300,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: 'b0be4075-b760-41ca-9671-0d2b0b2f4f1b',
          type: 'Tween',
          name: 'sparkle1_1_copy_1_copy',
          duration: 150,
          track: 2,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1310,
          sourceName: 'sparkle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c33d5dcc-dea9-44fb-bed5-7ebf81d0f3e2',
          type: 'Setter',
          name: 'sparkle1_copy',
          track: 1,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 1500,
          sourceName: 'sparkle1',
          disabled: false
        },
        {
          id: '2dae2ede-3906-4430-b524-519b11e02c1a',
          type: 'Tween',
          name: 'sparkle1_1_copy',
          duration: 150,
          track: 1,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1510,
          sourceName: 'sparkle1',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class GoldenHeadStartPopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  blackOverlay!: Sprite & { data: typeof raw['list'][1]['data'] };
  popup!: Container & { data: typeof raw['list'][2]['data'] };
  backgroundSprite1!: Sprite;
  closeButton!: Sprite;
  titleText!: Text & { data: typeof raw['list'][5]['data'] };
  timerText!: Text;
  descriptionText!: Text & { data: typeof raw['list'][7]['data'] };
  badgeContainer!: Container;
  rewardSlot1!: Container;
  coinPile!: Container;
  buyButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][11]['data'] };
  badgeTextBig!: Text;
  badgeTextSmall!: Text;
  buttonLabel!: Text;
  sparkle1!: Sprite;
  sparkle2!: Sprite;
  sparkle3!: Sprite;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][2]['data'] })[];
  replaceText_SPL!: (Text & { data: typeof raw['list'][17]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    blackOverlay: object;
    backgroundSprite1: object;
    closeButton: object;
    titleText: object;
    timerText: object;
    descriptionText: object;
    badgeText: object;
    coinPile: object;
    button: object;
    limitText: object;
    badgeText2: object;
    badgeContainer: object;
  };

  BlockTypeByName: {
    blackOverlayAlpha: object;
    backgroundSprite1Alpha: object;
    closeButtonScale: object;
    titleTextAlpha: object;
    timerTextAlpha: object;
    descriptionTextAlpha: object;
    badgeTextAlpha: object;
    rewardSlot1Scale: object;
    buttonScale: object;
    limitTextAlpha: object;
    badgeText2Alpha: object;
    badgeScale0: object;
    blackOverlayAlpha: object;
    badgeText2Alpha: object;
    badgeTextAlpha: object;
    descriptionTextAlpha: object;
    timerTextAlpha: object;
    titleTextAlpha: object;
    backgroundSprite1Alpha: object;
    buttonScale: object;
    rewardSlot1Scale: object;
    closeButtonScale: object;
    badgeScaleAnim: object;
    buttonScale: object;
    rewardSlot1Scale: object;
    closeButtonScale: object;
    limitTextAlpha: object;
  };

  flowData = raw.animations[0];
}

export abstract class Disappear {
  Layout: {
    closeButton: object;
    coinPile: object;
    button: object;
    badgeText2: object;
    limitText: object;
    badgeContainer: object;
    descriptionText: object;
    timerText: object;
    titleText: object;
    backgroundSprite1: object;
    blackOverlay: object;
  };

  BlockTypeByName: {
    closeButtonScale: object;
    rewardSlot1Scale: object;
    buttonScale: object;
    badgeText2Alpha: object;
    limitTextAlpha: object;
    badgeTextAlpha: object;
    descriptionTextAlpha: object;
    timerTextAlpha: object;
    titleTextAlpha: object;
    backgroundSprite1Alpha: object;
    blackOverlayAlpha: object;
    buttonScale: object;
    rewardSlot1Scale: object;
    closeButtonScale: object;
  };

  flowData = raw.animations[1];
}

export abstract class Idle {
  Layout: {
    sparkle1: object;
    sparkle2: object;
    sparkle3: object;
  };

  BlockTypeByName: {
    sparkle1: object;
    sparkle1_1: object;
    sparkle2: object;
    sparkle1_1_copy_1: object;
    sparkle1_1_copy_1_copy_1: object;
    sparkle2_copy: object;
    sparkle3: object;
    sparkle2_copy_copy: object;
    sparkle3_copy: object;
    sparkle2_copy_1: object;
    sparkle1_1_copy_1_copy: object;
    sparkle1_copy: object;
    sparkle1_1_copy: object;
  };

  flowData = raw.animations[2];
}
